<template>
    <div v-if="loading" class="text-center">
        <v-progress-circular indeterminate color="primary" :size="90"></v-progress-circular>
    </div>
    <div v-else>
        <div v-if="showPricingTable">
            <v-card :min_width=min_width elevation=0 class="rounded-card">
                <v-card-text>
                    <v-row class="pr-5 pl-5">
                        <v-col cols="12">
                            <div>
                                <div>
                                    <v-card class="mt-6 section">
                                        <v-card-text class="card">
                                            <v-col cols="8">
                                                <v-row class="header-row">
                                                    <v-col cols="3" class="pt-1 pb-1">Section</v-col>
                                                    <v-col cols="4" class="pt-1 pb-1">Description</v-col>
                                                    <v-col cols="3" class="pt-1 pb-1">Value </v-col>
                                                    <v-col cols="1" class="pt-1 pb-1"></v-col>
                                                    <v-col cols="1" class="pt-1 pb-1"></v-col>
                                                </v-row>
                                            </v-col>
                                            <v-row>
                                                <v-col cols="8" class="pt-1 pb-1">
                                                    <v-row class="custom-row">
                                                        <v-col cols="12">
                                                            <v-row v-for="item in tablePresets.entries" :key="item.id">
                                                                <v-col cols="3" class="d-flex align-center pt-1 pb-1">
                                                                    <v-select v-model="item.section"
                                                                        :items="defaultTablePricingSections"></v-select>
                                                                </v-col>
                                                                <v-col cols="4" class="pt-1 pb-1">
                                                                    <v-text-field v-model="item.name"
                                                                        @input="updatePricingTableDescription($event)"
                                                                        @paste="handlePasteDescription($event, item)">
                                                                    </v-text-field>
                                                                </v-col>
                                                                <v-col cols="3" class="pt-1 pb-1">
                                                                    <v-text-field v-model="item.token"
                                                                        @input="updateTablePrice($event, item)">
                                                                    </v-text-field>
                                                                </v-col>
                                                                <v-col cols="1" class="pt-1 pb-1">
                                                                    <v-switch v-model="item.active" color="indigo"
                                                                        :value="item.active"></v-switch>
                                                                </v-col>
                                                                <v-col cols="1" class="d-flex align-center pt-1 pb-1">
                                                                    <v-btn icon color="red"
                                                                        @click="removePricingTableItem(item.id)">
                                                                        <v-icon large>mdi-delete</v-icon>
                                                                    </v-btn>
                                                                </v-col>
                                                            </v-row>
                                                            <div class="custom-hr"></div>
                                                        </v-col>

                                                    </v-row>


                                                    <v-row>
                                                        <v-col cols="3">
                                                            <v-btn outlined color="primary" class="mr-2 text-capitalize"
                                                                @click="addPricintTableItem">
                                                                Add to table
                                                            </v-btn>
                                                        </v-col>
                                                    </v-row>
                                                </v-col>


                                                <v-col cols="4" class="pt-1 pb-1">
                                                    <div v-if="loadingTablePresetCalculations" class="text-center">
                                                        <v-progress-circular indeterminate color="primary"
                                                            :size="90"></v-progress-circular>
                                                    </div>
                                                    <v-card v-else color="#E0E0E0" class="pt-3 pl-3 pr-3">
                                                        <h2 class="pb-3 pt-3">Pricing Asumptions</h2>
                                                        <div class="d-flex justify-space-between" style="gap:10px"
                                                            :class="(item.errorValue || item.errorDescription) ? 'red--text' : ''"
                                                            v-for="item in tablePresets.entries.filter(v => v.section == 'Pricing Asumptions' && v.active && v.name && v.token)"
                                                            :key="item.id">
                                                            <div>
                                                                <p>{{ item.previewName }}</p>
                                                            </div>
                                                            <div>
                                                                <span>{{ item.previewValue }}</span>
                                                                <v-tooltip bottom
                                                                    v-if="(item.errorValue || item.errorDescription)">
                                                                    <template v-slot:activator="{ on, attrs }">
                                                                        <v-icon color="primary" dark v-bind="attrs"
                                                                            v-on="on">
                                                                            mdi-help-circle
                                                                        </v-icon>
                                                                    </template>
                                                                    <span>*ERROR. this means the token's value could not
                                                                        be calculated, this probably means there is a
                                                                        cyclical dependency
                                                                        in the calculation</span>
                                                                </v-tooltip>
                                                            </div>
                                                        </div>
                                                        <h2 class="pb-3 pt-3">Setup & Installation Fees</h2>
                                                        <div class="d-flex justify-space-between" style="gap:10px"
                                                            :class="(item.errorValue || item.errorDescription) ? 'red--text' : ''"
                                                            v-for="item in tablePresets.entries.filter(v => v.section == 'Setup & Installation Fees' && v.active && v.name && v.token)"
                                                            :key="item.id">
                                                            <div>
                                                                <p>{{ item.previewName }}</p>
                                                            </div>
                                                            <div>
                                                                <span>{{ item.previewValue }}</span>
                                                                <v-tooltip bottom
                                                                    v-if="(item.errorValue || item.errorDescription)">
                                                                    <template v-slot:activator="{ on, attrs }">
                                                                        <v-icon color="primary" dark v-bind="attrs"
                                                                            v-on="on">
                                                                            mdi-help-circle
                                                                        </v-icon>
                                                                    </template>
                                                                    <span>*ERROR. this means the token's value could not
                                                                        be calculated, this probably means there is a
                                                                        cyclical
                                                                        dependency in the calculation</span>
                                                                </v-tooltip>
                                                            </div>
                                                        </div>
                                                        <div class="d-flex justify-space-between">
                                                            <div>
                                                                <h4>Total</h4>
                                                            </div>
                                                            <div>
                                                                <h4>{{ totalPricingSectionTablePreset('Setup & Installation Fees')}}</h4>
                                                            </div>
                                                        </div>
                                                        <h2 class="pb-3 pt-3">Annual Fee</h2>
                                                        <div class="d-flex justify-space-between" style="gap:10px"
                                                            :class="(item.errorValue || item.errorDescription) ? 'red--text' : ''"
                                                            v-for="item in tablePresets.entries.filter(v => v.section == 'Annual Fee' && v.active && v.name && v.token)"
                                                            :key="item.id">
                                                            <div>
                                                                <p>{{ item.previewName }}</p>
                                                            </div>
                                                            <div>
                                                                <span>{{ item.previewValue }}</span>
                                                                <v-tooltip bottom
                                                                    v-if="(item.errorValue || item.errorDescription)">
                                                                    <template v-slot:activator="{ on, attrs }">
                                                                        <v-icon color="primary" dark v-bind="attrs"
                                                                            v-on="on">
                                                                            mdi-help-circle
                                                                        </v-icon>
                                                                    </template>
                                                                    <span>*ERROR. this means the token's value could not
                                                                        be calculated, this probably means there is a
                                                                        cyclical
                                                                        dependency in the calculation</span>
                                                                </v-tooltip>
                                                            </div>
                                                        </div>
                                                        <div class="d-flex justify-space-between ">
                                                            <div>
                                                                <h4>Total</h4>
                                                            </div>
                                                            <div>
                                                                <h4>{{ totalPricingSectionTablePreset('Annual Fee') }}
                                                                </h4>
                                                            </div>
                                                        </div>
                                                        <br />
                                                    </v-card>
                                                </v-col>

                                            </v-row>
                                        </v-card-text>
                                    </v-card>
                                </div>
                            </div>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { defaultTokenList, defaultSections, addEmptyPricingTableItem, updatePricingTablePreviews, cleanNumber, handleThousandFormat } from '../store/global_helpers/utility';


export default {
    props: {
        // if update mode is true load data
        // otherwise don't
        updateMode: [Boolean],
        context: [Object],
    },

    data: () => ({
        duration_selected: 5,

        plan_opportunity_id: null, // ONLY USE ON UPDATE MODE
        loading: true,
        loadingTablePresetCalculations: false,
        defaultTablePricingSections: defaultSections,
        dialog: false,
        showDeleteDialog: false,
        pricingTableName: '',
        pricingTableScope: "only for me",
        selectedPricingTable: "",
        isPricingTableLoading: false,
        dataContext: undefined,
        chromeExtensionPort: undefined,
        showPricingTable: false

    }),

    async mounted() {
        window.scrollTo(0, 0)
        //   this.setTablePreset(this.dataContext)
        // this.addPricingTableListener()

        // await this.sendMessage()
        updatePricingTablePreviews(this.dataContext, this.tablePresets)
        const extensionId = process.env.VUE_APP_EXTENSION_ID || "";
        if (extensionId) {
            this.chromeExtensionPort = await window.chrome.runtime.connect(extensionId, { name: "port-from-webApp" });
            console.log(`myPort = ${JSON.stringify(this.chromeExtensionPort)}`)
        }
        this.chromeExtensionPort.onMessage.addListener((message) => {
            if (message.action === "updateContext") {
                console.log("In background script, received message from webApp");
                console.log(JSON.stringify(message));
                this.dataContext = message.data
                updatePricingTablePreviews(this.dataContext, this.tablePresets)
                this.showPricingTable = true
            }else if(message.action === "showPricingTable"){
                this.dataContext = message.data
                updatePricingTablePreviews(this.dataContext, this.tablePresets)
                this.showPricingTable = true
            } else if (message.action === "hidePricingTable") {
                this.showPricingTable = false
                this.initTablePricing()
                // this.tablePresets = undefined
                this.dataContext = undefined
            }
        });
        this.loading = false
        //   const extensionId = process.env.VUE_APP_EXTENSION_ID || "";
        //     if (extensionId) {
        //         console.log("send message")
        //         console.log(`extensionId = ${extensionId}`)
        //         const resp = await window?.chrome?.runtime?.sendMessage(extensionId, { action: "pricingTable", data: "started" })
        //         console.log(`RESP = ${JSON.stringify(resp)}`)
        //     }
    },

    created() {
        this.formatterCurrency = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            maximumFractionDigits: 0,
        });


    },
    computed: {
        ...mapGetters({
            isUpdate: 'getIsUpdate',
            globalContext: 'globalContext',
            //   dataContext: "getDataContext",
            tablePresets: "getTablePresetItems",
            lastSavedPricingTableState: 'getLastPricingTablePresetState',
        }),

        min_width() {
            switch (this.$vuetify.breakpoint.name) {
                case 'xs': return 200;
                case 'sm': return 400;
                case 'md': return 800;
                case 'lg': return 800;
                case 'xl': return 1200;
            }
            return null;
        },
    },

    watch: {
        'tablePresets': {
            deep: true,
            async handler() {
                try {
                    this.isPendingToSave = this.lastSavedPricingTableState && JSON.stringify(this.lastSavedPricingTableState) !== JSON.stringify(this.tablePresets)
                    console.log(`table preset changed`)
                    const extensionId = process.env.VUE_APP_EXTENSION_ID || "";
                    if (extensionId) {
                        console.log("send message")
                        console.log(`extensionId = ${extensionId}`)
                        // const resp = await window?.chrome?.runtime?.sendMessage(extensionId, { action: "pricingTableUpdated", data: this.tablePresets })
                        this.chromeExtensionPort.postMessage({ action: "pricingTableUpdated", data: this.tablePresets })
                        // console.log(`resp = ${JSON.stringify(resp)}`)
                        // this.dataContext = resp.data
                        // console.log(`RESP = ${JSON.stringify(resp)}`)
                    }
                    // this.debouncedFetch(...args)
                } catch (error) {
                    console.log("error loading ")
                }
                // this.loadingTablePresetCalculations = false
            },
        },
    },




    methods: {
        ...mapActions([
            // 'loadRevSharePrograms',
            // 'loadProposalTemplates',
            // 'clearPlanOpportunityViewModelState',
            // 'clearProposalBuilderState',
            // 'clearProposalViewModels',
            // 'loadWholesalerTemplatePairs',
            // 'loadBrokerDealers',
            // 'loadDefaultPricing',
            // 'loadDefaultPricingOptions',
            // 'getProposalViewModelCalculation',
            // 'getProposalViewModelCalculation2',
            // 'loadSavedProposalBuilder',
            // 'clearPlanOpportunityState',
            // 'clearSavedProgramsState',
            // 'clearSavedBrokerDealerIsNoBroker',
            // 'clearSavedAdvisor',
            // 'updatePlanOpportunity',
            // 'loadWholesalers',
            // 'loadTemplates',

            // 'clearBrokerState',
            // 'move_brokerDDL_to_brokerRadio',
            // 'loadBrokerForm',
            // 'updateBrokerDefaults',

            // 'loadAdvisorState',
            // 'clearAdvisorState',
            // 'move_advisorDDL_to_advisorRadio',
            // 'createAdvisorAndLoadForm',
            // 'loadAdvisorForm',
            // 'raiseMessage',
            // 'updateTablePreset',
            // 'loadPricingTables',
            // 'savePricingTables',
            // 'loadTablePricingData',
            'updatelastTablePricingState',
            'updatePricingTable',
            'setTablePreset',
            // 'clearSavedSelectedPricingTable',
            // 'deletePricingTable',
            'initTablePricing'
        ]),
        removePricingTableItem(id) {
            this.tablePresets.entries = this.tablePresets.entries.filter(v => v.id != id)
        },

        handlePasteDescription(e, item) {
            let paste = (e.clipboardData || window.clipboardData).getData("text");
            if (paste) {
                const defaultValues = defaultTokenList()
                const currentDescription = defaultValues.find(v => {
                    return v.name == paste
                })
                if (currentDescription) {
                    item.token = currentDescription.token
                    this.updatePricingTablePreviews(this.dataContext, this.tablePresets)
                }
            }
        },
        async sendMessage() {
            const extensionId = process.env.VUE_APP_EXTENSION_ID || "";
            if (extensionId) {
                console.log("send message")
                console.log(`extensionId = ${extensionId}`)
                const resp = await window?.chrome?.runtime?.sendMessage(extensionId, { action: "pricingTable", data: "started" })
                console.log(`resp = ${JSON.stringify(resp)}`)
                this.dataContext = resp.data
                // console.log(`RESP = ${JSON.stringify(resp)}`)
            }
        },

        addPricingTableListener() {
            // window?.chrome?.runtime?.onMessage?.addListener(
            //         async (request, sender) => {
            //             console.log(sender.tab ?
            //                 "from a pipeline:" + sender.tab.url :
            //                 "from the extension");
            //             if (request && request.action == "updatePricingTable") {
            //                 this.dataContext = request.data
            //             }
            //         })

            window.chrome.runtime.onMessage.addListener((message) => {
                console.log(`MEssage = ${JSON.stringify(message)}`)
            })
        },

        addPricintTableItem() {
            addEmptyPricingTableItem(this.tablePresets)
        },

        updatePricingTableDescription() {
            updatePricingTablePreviews(this.dataContext, this.tablePresets)
        },

        isNumber(num) {
            return num && !isNaN(num.toString().replaceAll("$", "").replaceAll(",", ""))
        },

        isValidPricingTable() {
            return this.tablePresets?.entries.filter(v => v.errorValue || v.errorDescription).length == 0 || false
        },

        ispricingTableCalculateDisabled() {
            return !this.isValidPricingTable()
        },

        updateTablePrice(e, item) {
            item.token = handleThousandFormat(item.token)
            updatePricingTablePreviews(this.dataContext, this.tablePresets)
        },

        totalPricingSectionTablePreset(section) {
            let total = 0;
            this.tablePresets.entries.filter(v => v.section === section && v.active && v.name && v.token).forEach(item => {
                const currentValue = item.previewValue ? item.previewValue : 0
                const formattedValue = cleanNumber(this.isNumber(currentValue) ? currentValue : 0)
                total += formattedValue ? Number(formattedValue) : 0
            })
            return this.formatterCurrency.format(total)
        },

        savePricingTable() {
            alert('TODO');
        },
    }
};
</script>

<style type="text/css" scoped>
hr {
    border: none;
    border-top: solid 2px #ccc;
}

.text {
    font-size: 18px;
    padding-top: 10px;
    margin-top: 16px;
}

.section {
    min-width: 100%;
}

.rounded-card {
    border-radius: 20px !important;
}

.theme--light.v-sheet--outlined {
    border: thin solid rgb(0, 0, 0, 30%);
}

.center {
    align-items: center;
}
</style>
